import classNames from 'classnames';
import React from 'react';

import { SIZE } from './constants';
import styles from './tabs.module.scss';

export interface ITabProps {
  className?: string;
  size?: keyof typeof SIZE;
  text: string;
  index: number;
  active: boolean;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
}

export const Tab = (props: ITabProps) => {
  const { text, index, active = false, className, onChange, size } = props;

  return (
    <div className={classNames(styles.tab, styles[`tab--size-${size}`], className)} role="tab">
      <label className={styles.control}>
        <input className={styles.input} value={index} checked={active} readOnly type="radio" onChange={onChange} />
        <span className={classNames(styles.label, active && styles['label--active'])}>{text}</span>
      </label>
    </div>
  );
};
